import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "gatsby";

import "./ImpulsionarCurriculo.css";

export default function ImpulsionarCurriculo({
	cursoSelecionado,
	titulo = "VENHA IMPULSIONAR SEU CURRÍCULO",
}) {
	const informacoes = cursoSelecionado?.Informacoes;

	const modalidadeRaw = informacoes?.Modalidade?.Value;
	const local = informacoes?.Local?.Value;

	/*
	 * Mantém a mesma lógica visual usada em Informações do curso:
	 * Hibrido é apresentado como Presencial.
	 * Para este bloco trabalhamos com os dois modelos principais:
	 * EAD ou Presencial.
	 */
	const isEad = modalidadeRaw === "EAD";
	const isSemipresencial = modalidadeRaw === "Semipresencial";

	const modalidade = isEad
		? "EAD"
		: isSemipresencial
		? "Semipresencial"
		: "Presencial";

	const conteudoModalidade =
		modalidade === "EAD"
			? {
					descricao:
						"Estude com a qualidade Feevale de onde estiver, com recursos digitais, aulas online e acompanhamento ao longo da sua formação.",
					titulo: "Como funciona o curso a distância",
					texto:
						"A metodologia da Feevale Online permite que você estude no seu ritmo, de qualquer lugar. As videoaulas e os recursos multimídia ficam disponíveis a qualquer momento, as aulas ao vivo são gravadas e as avaliações são realizadas online, com opção de prova presencial no polo de vínculo.",
			  }
			: modalidade === "Semipresencial"
			? {
					descricao:
						"Tenha mais flexibilidade para organizar seus estudos, combinando experiências presenciais com atividades a distância sem abrir mão da qualidade Feevale.",
					titulo: "Como funciona o curso semipresencial",
					texto:
						"O formato semipresencial combina componentes e atividades presenciais com momentos de aprendizagem a distância. Assim, você ganha mais autonomia para organizar sua rotina e, ao mesmo tempo, mantém o contato com professores, colegas e a estrutura da Universidade.",
			  }
			: {
					descricao:
						"Viva a experiência Feevale de perto, com aulas, projetos e atividades práticas, contato direto com professores e colegas e acesso à estrutura da Universidade.",
					titulo: "Como funciona o curso presencial",
					texto:
						"No modelo presencial, você participa de aulas, projetos e experiências práticas nos espaços da Feevale, com acesso a laboratórios, ambientes de inovação e toda a estrutura necessária para aproximar o aprendizado da realidade profissional.",
			  };

	const getLocalInfo = () => {
		switch (local) {
			case "Polos":
				return {
					titulo: "Polos Feevale",
					destaque: "Conheça nossos polos",
					texto:
						"Encontre a unidade mais próxima para suporte presencial, atividades e avaliações.",
					url: "/polos",
					botao: "Ver Polos",
					interno: true,
				};

			case "Câmpus I":
				return {
					titulo: "Onde você vai estudar",
					destaque: "Câmpus I",
					texto:
						"Conheça a estrutura, os espaços e os serviços disponíveis no Câmpus I da Universidade Feevale.",
					url: "https://www.feevale.br/institucional/infraestrutura/campus-i",
					botao: "Conheça o Câmpus I",
					interno: false,
				};

			case "Câmpus II":
				return {
					titulo: "Onde você vai estudar",
					destaque: "Câmpus II",
					texto:
						"Conheça a estrutura, os espaços e os serviços disponíveis no Câmpus II da Universidade Feevale.",
					url: "https://www.feevale.br/institucional/infraestrutura/campus-ii",
					botao: "Conheça o Câmpus II",
					interno: false,
				};

			case "Câmpus III":
				return {
					titulo: "Onde você vai estudar",
					destaque: "Câmpus III",
					texto:
						"Conheça a estrutura, os espaços e os serviços disponíveis no Câmpus III da Universidade Feevale.",
					url: "https://www.feevale.br/institucional/infraestrutura/campus-iii",
					botao: "Conheça o Câmpus III",
					interno: false,
				};

			default:
				return null;
		}
	};

	const localInfo = getLocalInfo();

	return (
		<section className="impulsionarCurriculo">
			<Container>
				<Row className="impulsionarCurriculo-topo align-items-start">
					<Col lg={7}>
						<h2>{titulo}</h2>
						<div className="impulsionarCurriculo-descricao">
							{conteudoModalidade.descricao}
						</div>
					</Col>
				</Row>

				<div className="impulsionarCurriculo-box">
					<Row className="h-100">
						<Col
							md={localInfo ? 7 : 12}
							className="impulsionarCurriculo-col impulsionarCurriculo-col--modelo"
						>
							<div className="impulsionarCurriculo-label">
								<i
									className={isEad || isSemipresencial ? "far fa-clock" : "fas fa-university"}
									aria-hidden="true"
								/>
								<span>{conteudoModalidade.titulo}</span>
							</div>

							<p>{conteudoModalidade.texto}</p>
						</Col>

						{localInfo && (
							<Col
								md={5}
								className="impulsionarCurriculo-col impulsionarCurriculo-col--local"
							>
								<div className="impulsionarCurriculo-label">
									<i
										className="fas fa-map-marker-alt"
										aria-hidden="true"
									/>
									<span>{localInfo.titulo}</span>
								</div>

								<h3>{localInfo.destaque}</h3>

								<p className="impulsionarCurriculo-localTexto">
									{localInfo.texto}
								</p>

								{localInfo.interno ? (
									<Link
										to={localInfo.url}
										className="impulsionarCurriculo-btn impulsionarCurriculo-btn--light"
									>
										{localInfo.botao}
									</Link>
								) : (
									<a
										href={localInfo.url}
										target="_blank"
										rel="noreferrer"
										className="impulsionarCurriculo-btn impulsionarCurriculo-btn--light"
									>
										{localInfo.botao}
									</a>
								)}
							</Col>
						)}
					</Row>
				</div>
			</Container>
		</section>
	);
}

ImpulsionarCurriculo.propTypes = {
	cursoSelecionado: PropTypes.object,
	titulo: PropTypes.node,
};
